// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.projectinfo__content {
  margin-top: 25px;
  margin-bottom: 25px;
}
.projectinfo__image img {
  display: block;
  margin: 0 auto;
  height: 200px;
  border-radius: 10px;
}
@media (max-width: 575px) {
  .projectinfo__image img {
    width: 450px;
    height: 150px;
  }
}
@media (max-width: 470px) {
  .projectinfo__image img {
    width: 400px;
  }
}
@media (max-width: 410px) {
  .projectinfo__image img {
    width: 350px;
  }
}
.projectinfo__information {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}
.projectinfo__number, .projectinfo__name, .projectinfo__date {
  font-size: 22px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  padding-right: 15px;
}
@media (max-width: 575px) {
  .projectinfo__number, .projectinfo__name, .projectinfo__date {
    font-size: 18px;
  }
}
.projectinfo__filter {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .projectinfo__filter-card {
    overflow-x: auto;
  }
}
.projectinfo__filter-card__content {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 460px) {
  .projectinfo__filter-card__content {
    width: 385px;
  }
}
@media (max-width: 400px) {
  .projectinfo__filter-card__content {
    width: 350px;
  }
}
@media (max-width: 350px) {
  .projectinfo__filter-card__content {
    width: 300px;
  }
}
.projectinfo__filter-card__item {
  font-size: 18px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 10px;
  list-style: none;
  transition: background-color 0.1s ease-in-out;
}
@media (max-width: 768px) {
  .projectinfo__filter-card__item {
    white-space: nowrap;
  }
}
@media (max-width: 575px) {
  .projectinfo__filter-card__item {
    font-size: 14px;
    padding: 10px 15px;
  }
}
@media (max-width: 500px) {
  .projectinfo__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 450px) {
  .projectinfo__filter-card__item {
    padding: 5px 13px;
  }
}
@media (max-width: 450px) {
  .projectinfo__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 400px) {
  .projectinfo__filter-card__item {
    font-size: 13px;
  }
}
.projectinfo__filter-card__item:hover {
  background-color: #23232d;
  color: white;
}
.projectinfo__filter-card__item:active {
  background-color: #1c1d25;
}
.projectinfo__filter-card__item.active {
  background-color: #1c1d25;
  color: white;
}
.projectinfo .cabinet__item {
  font-size: 22px;
  font-weight: 400;
  color: #0000ff;
  padding-right: 15px;
  cursor: pointer;
}
.projectinfo .cabinet__item:hover {
  color: #f80000;
}
@media (max-width: 575px) {
  .projectinfo .cabinet__item {
    font-size: 18px;
    padding-top: 20px;
  }
}
.projectinfo .table-planning {
  width: 350px;
}
.projectinfo .table-production {
  overflow-x: auto;
  width: 100%;
}
.projectinfo .table-production__th {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: #ffffff;
  text-align: center;
}
.projectinfo .table-production__th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  border-right: solid 1px #dee2e6;
  border-bottom: solid 1px #dee2e6;
}
.projectinfo .table-complaint__note {
  width: 450px;
}
.projectinfo .table-complaint__date {
  width: 50px;
  text-align: center;
}
.projectinfo .note {
  margin-bottom: 25px;
}
.projectinfo .note__title {
  padding-left: 20px;
  font-size: 22px;
  font-weight: 500;
  color: rgb(7, 7, 7);
}
@media (max-width: 768px) {
  .projectinfo .note__title {
    font-size: 18px;
  }
}
.projectinfo .note__content {
  margin: 25px 0px 15px 0px;
  padding: 20px;
  width: 100%;
  min-height: 200px;
  border-radius: 10px;
  border: 2px solid #9da1aa;
}
.projectinfo .note__field {
  font-size: 19px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  font-family: "Open Sans", sans-serif;
  white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */
  word-break: break-word;
}
@media (max-width: 1024px) {
  .projectinfo .note__field {
    white-space: pre-wrap;
  }
}
@media (max-width: 768px) {
  .projectinfo .note__field {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .projectinfo .note__field {
    font-size: 14px;
  }
}
.projectinfo .note__show {
  font-size: 17px;
  font-weight: 400;
  color: #7d7f7d;
  text-align: center;
  cursor: pointer;
}
@media (max-width: 768px) {
  .projectinfo .note__show {
    font-size: 14px;
  }
}

.user-file {
  margin-top: 25px;
}
.user-file__item {
  display: flex;
}
.user-file__name {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin-right: 15px;
  cursor: pointer;
}
@media (max-width: 490px) {
  .user-file__name {
    font-size: 16px;
    margin-right: 6px;
  }
}
.user-file__delete {
  font-size: 18px;
  font-weight: 600;
  color: #FF0000;
  cursor: pointer;
}
@media (max-width: 490px) {
  .user-file__delete {
    font-size: 16px;
    margin-right: 6px;
  }
}

.project-logistic {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ProjectInfoList/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACZ;EACI,gBAAA;EACA,mBAAA;AACR;AAEQ;EACI,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAAZ;AACY;EALJ;IAMQ,YAAA;IACA,aAAA;EAEd;AACF;AADY;EATJ;IAUQ,YAAA;EAId;AACF;AAHY;EAZJ;IAaQ,YAAA;EAMd;AACF;AADI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AAGR;AACI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AACR;AAAQ;EALJ;IAMQ,eAAA;EAGV;AACF;AAAI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAER;AAEW;EAFH;IAII,gBAAA;EAAV;AACF;AAGY;EACI,aAAA;EACA,8BAAA;AADhB;AAEgB;EAHJ;IAIQ,YAAA;EAClB;AACF;AAAgB;EANJ;IAOQ,YAAA;EAGlB;AACF;AAFgB;EATJ;IAUQ,YAAA;EAKlB;AACF;AAFY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;AAIhB;AAHgB;EATJ;IAUQ,mBAAA;EAMlB;AACF;AALgB;EAZJ;IAaQ,eAAA;IACA,kBAAA;EAQlB;AACF;AAPgB;EAhBJ;IAiBQ,iBAAA;EAUlB;AACF;AATgB;EAnBJ;IAoBQ,iBAAA;EAYlB;AACF;AAXgB;EAtBJ;IAuBQ,iBAAA;EAclB;AACF;AAbgB;EAzBJ;IA0BQ,eAAA;EAgBlB;AACF;AAdgB;EACE,yBAAA;EACA,YAAA;AAgBlB;AAbgB;EACE,yBAAA;AAelB;AAXgB;EACI,yBAAA;EACA,YAAA;AAapB;AANQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAQZ;AAPY;EACI,cAAA;AAShB;AAPY;EATJ;IAUQ,eAAA;IACA,iBAAA;EAUd;AACF;AAHI;EACI,YAAA;AAKR;AAAI;EACI,gBAAA;EACA,WAAA;AAER;AAAQ;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAEZ;AAEQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;AAAZ;AAQQ;EACI,YAAA;AANZ;AAUQ;EACI,WAAA;EACA,kBAAA;AARZ;AAeI;EACI,mBAAA;AAbR;AAcQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAZZ;AAaY;EALJ;IAMQ,eAAA;EAVd;AACF;AAaQ;EACI,yBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAXZ;AAeQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA,EAAA,iDAAA;EACA,sBAAA;AAbZ;AAcY;EAPJ;IAQQ,qBAAA;EAXd;AACF;AAYY;EAVJ;IAWQ,eAAA;EATd;AACF;AAUY;EAbJ;IAcQ,eAAA;EAPd;AACF;AAUQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AARZ;AASY;EANJ;IAOQ,eAAA;EANd;AACF;;AAWA;EACI,gBAAA;AARJ;AAUI;EACI,aAAA;AARR;AAWI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AATR;AAUQ;EANJ;IAOQ,eAAA;IACA,iBAAA;EAPV;AACF;AAUI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AARR;AASQ;EALJ;IAMQ,eAAA;IACA,iBAAA;EANV;AACF;;AAWA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AARJ","sourcesContent":[".projectinfo {\n    &__content {\n        margin-top: 25px;\n        margin-bottom: 25px;\n    }\n    &__image {\n        img {\n            display: block;\n            margin: 0 auto;\n            height: 200px;\n            border-radius: 10px;\n            @media(max-width: 575px) {\n                width: 450px;\n                height: 150px;\n            }\n            @media(max-width: 470px) {\n                width: 400px;\n            }\n            @media(max-width: 410px) {\n                width: 350px;\n            }\n        }  \n\n    }\n\n    &__information {\n        margin-top: 25px;\n        display: flex;\n        justify-content: center;\n        \n    } \n\n    &__number, &__name, &__date {\n        font-size: 22px;\n        font-weight: 400;\n        color: rgb(7, 7, 7);\n        padding-right: 15px;\n        @media(max-width: 575px) {\n            font-size: 18px;\n        }\n    }\n\n    &__filter {\n        margin-top: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &-card {\n            \n           @media(max-width: 768px){\n           \n            overflow-x: auto;\n           }\n            \n\n            &__content {\n                display: flex;\n                justify-content: space-between;\n                @media(max-width: 460px) {\n                    width: 385px;\n                }\n                @media(max-width: 400px) {\n                    width: 350px;\n                }\n                @media(max-width: 350px) {\n                    width: 300px;\n                }\n            }\n\n            &__item {\n                font-size: 18px;\n                font-weight: 400;\n                color: rgb(7,7,7);\n                cursor: pointer;\n                padding: 10px 20px;\n                border-radius: 10px;\n                list-style: none;\n                transition: background-color 0.1s ease-in-out;\n                @media(max-width: 768px) {\n                    white-space: nowrap\n                }\n                @media(max-width: 575px) {\n                    font-size: 14px;\n                    padding: 10px 15px;\n                }\n                @media (max-width: 500px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 13px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 400px) {\n                    font-size: 13px;\n                }\n          \n                &:hover {\n                  background-color: darken(#272833, 2%);\n                  color: #ffff;\n                }\n          \n                &:active {\n                  background-color: darken(#272833, 5%);\n                 \n                }\n          \n                &.active {\n                    background-color: darken(#272833, 5%);\n                    color: #ffff;\n                  }\n            }\n        }\n    }\n\n    .cabinet {\n        &__item {\n            font-size: 22px;\n            font-weight: 400;\n            color: #0000ff;\n            padding-right: 15px;\n            cursor: pointer;\n            &:hover {\n                color: #f80000;\n            }\n            @media(max-width: 575px) {\n                font-size: 18px;\n                padding-top: 20px;\n            }\n\n\n        }\n    }\n\n    //table planning \n    .table-planning {\n        width: 350px;\n    }\n    \n\n    //table-production \n    .table-production {\n        overflow-x: auto;\n        width: 100%;\n\n        &__th {\n            padding: 5px !important;\n            position: sticky;\n            left: 0;\n            top: 0;\n            z-index: 3;\n            background-color: #ffffff;\n            text-align: center;\n           \n        }\n\n        &__th::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            right: 0;\n            height: 100%;\n            width: 100%;\n            border-right: solid 1px #dee2e6;\n            border-bottom: solid 1px #dee2e6;\n          \n        }\n       \n    }\n\n    //table-complaint \n    .table-complaint {\n        &__note {\n            width: 450px;\n            \n        }\n\n        &__date {\n            width: 50px;\n            text-align: center;\n        }\n    }\n\n    \n    // Note \n\n    .note {\n        margin-bottom: 25px;\n        &__title {\n            padding-left: 20px;\n            font-size: 22px;\n            font-weight: 500;\n            color: rgb(7,7,7);\n            @media(max-width: 768px) {\n                font-size: 18px;\n            }\n        }\n\n        &__content {\n            margin: 25px 0px 15px 0px;\n            padding: 20px;\n            width: 100%;\n            min-height: 200px;\n            border-radius: 10px;\n            border: 2px solid #9da1aa;\n            \n        }\n\n        &__field {\n            font-size: 19px;\n            font-weight: 400;\n            color: rgb(7,7,7);\n            font-family: \"Open Sans\", sans-serif;\n            white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */\n            word-break: break-word;\n            @media(max-width: 1024px) {\n                white-space: pre-wrap;\n            }\n            @media(max-width: 768px) {\n                font-size: 16px;\n            }\n            @media(max-width: 480px) {\n                font-size: 14px;\n            }\n        }\n\n        &__show {\n            font-size: 17px;\n            font-weight: 400;\n            color: #7d7f7d;\n            text-align: center;\n            cursor: pointer;\n            @media(max-width: 768px) {\n                font-size: 14px;\n            }\n        }\n    }\n}\n//user-file\n.user-file {\n    margin-top: 25px;\n\n    &__item {\n        display: flex;\n    }\n\n    &__name {\n        font-size: 18px;\n        font-weight: 600;\n        color: #000000;\n        margin-right: 15px;\n        cursor: pointer;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            margin-right: 6px;\n        }\n    }\n\n    &__delete {\n        font-size: 18px;\n        font-weight: 600;\n        color: #FF0000;\n        cursor: pointer;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            margin-right: 6px;\n        }\n    }\n}\n\n//project-logistic\n.project-logistic {\n    margin-top: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
